import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'

import CreateEventCancel from '@/pages/CreateEventProcessingPage/ui/CreateEventCancel.vue'
import { mdiMinusCircleOutline, mdiPlus } from '@mdi/js'
import { EventDB } from '@/enitites/event'
import { computed, inject, onBeforeMount, ref } from 'vue'
import { CreateEventFormName } from '@/pages/CreateEventProcessingPage/model/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventTiers',
  props: {
    isNew: { type: Boolean },
    eventData: null,
    backStep: { type: Boolean }
  },
  emits: ["update:screen", "updateEvent", "saveAsDraft"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:screen', value: CreateEventFormName): void
  (e: 'updateEvent'): void
  (e: 'saveAsDraft'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isNew: boolean
  eventData: EventDB
  backStep: boolean
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore




const loadingNextBtn = ref(false)
const currentDotNav = ref(3)
const error = ref<string | null>(null)

function handlerClickBtnAddTier() {
  const id = props.eventData.tiers.length + 1
  props.eventData.tiers.push({
    fees: 0,
    taxes: 0,
    ticketCost: '',
    ticketFees: '',
    ticketTaxes: '',
    ticketTotalSum: '',
    totalSum: 0,
    id,
    title: '',
    cost: 0,
    description: '',
  })
}

const isShowBtnAddTier = computed(() => props.eventData.tiers.length < 10)
const injectedIsClickBtnNext = inject<{
  updateIsClickBtnNext: (value: boolean) => void
}>('isClickBtnNext')

function handlerClickNext() {
  error.value = null
  loadingNextBtn.value = true
  emit('updateEvent')
  injectedIsClickBtnNext?.updateIsClickBtnNext(true)
  emit('update:screen', props.backStep ? 'CreateEventTotal' : 'CreateEventDisplayMode')
  loadingNextBtn.value = false
}

function handlerClickBack() {
  injectedIsClickBtnNext?.updateIsClickBtnNext(false)
  emit('update:screen', 'CreateEventDate')
}

function handlerClickCancelEdit() {
  emit('update:screen', 'CreateEventTotal')
}

function setTierCost(tierId: number) {
  const tierItem = props.eventData.tiers.find((tier) => tier.id === tierId)
  if (!tierItem) return
  tierItem.cost = Math.abs(tierItem.cost)
  if (tierItem.cost > 0 && tierItem.cost < 1) tierItem.cost = 1
}

onBeforeMount(() => {
  if (props.eventData.tiers.length === 0) handlerClickBtnAddTier()
})

return { __sfc: true,emit, props, loadingNextBtn, currentDotNav, error, handlerClickBtnAddTier, isShowBtnAddTier, injectedIsClickBtnNext, handlerClickNext, handlerClickBack, handlerClickCancelEdit, setTierCost, store, CreateEventCancel, mdiMinusCircleOutline, mdiPlus }
}

})